export const runSummaryAgentReportStyles = {
  root: {
    p: 2,
    borderRadius: 2,
    bgcolor: 'background.paper',
    borderColor: 'custom.surfaceAlt',
    boxShadow: '0 10px 28px rgba(15, 23, 42, 0.04)',
    mb: 2,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: { xs: 'flex-start', md: 'center' },
    flexDirection: { xs: 'column', md: 'row' },
    gap: 1.5,
    mb: 2,
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  titleIcon: {
    width: 36,
    height: 36,
    borderRadius: 2,
    bgcolor: 'custom.surfaceAlt',
    color: 'info.main',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  title: {
    fontWeight: 800,
  },
  button: {
    color: 'primary.contrastText',
    bgcolor: 'primary.main',
    textTransform: 'none',
    fontWeight: 700,
    minWidth: 180,
    '&:hover': {
      bgcolor: 'custom.terminalAccentPurple',
    },
  },
  graphicsGrid: {
    display: 'grid',
    gridTemplateColumns: {
      xs: '1fr',
      sm: 'repeat(2, minmax(0, 1fr))',
      lg: 'repeat(4, minmax(0, 1fr))',
    },
    gap: 1.5,
    mb: 2,
  },
  graphicCard: {
    p: 1.5,
    borderRadius: 2,
    bgcolor: 'custom.surfaceAlt',
    border: '1px solid',
    borderColor: 'custom.surfaceAlt',
  },
  graphicValue: (color) => ({
    color,
    fontWeight: 800,
    lineHeight: 1.15,
  }),
  barTrack: {
    display: 'flex',
    height: 10,
    borderRadius: 999,
    overflow: 'hidden',
    bgcolor: 'custom.surfaceAlt',
    mb: 1.5,
  },
  barSegment: (width, bgcolor) => ({
    width: `${width}%`,
    bgcolor,
  }),
  reportBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  reportTabsRoot: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  reportTabs: {
    minHeight: 40,
    borderBottom: '1px solid',
    borderColor: 'custom.surfaceAlt',
    '& .MuiTab-root': {
      minHeight: 40,
      textTransform: 'none',
      fontWeight: 800,
    },
  },
  platformReportContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  trendGrid: {
    display: 'grid',
    gridTemplateColumns: {
      xs: '1fr',
      lg: 'repeat(2, minmax(0, 1fr))',
    },
    gap: 2,
  },
  reportPanel: {
    p: 1.5,
    borderRadius: 2,
    bgcolor: 'custom.surfaceAlt',
    border: '1px solid',
    borderColor: 'custom.surfaceAlt',
  },
  decisionPanel: {
    p: 2,
    borderRadius: 2,
    bgcolor: 'background.paper',
    border: '1px solid',
    borderColor: 'custom.surfaceAlt',
    boxShadow: '0 8px 22px rgba(15, 23, 42, 0.04)',
  },
  decisionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: { xs: 'flex-start', sm: 'center' },
    flexDirection: { xs: 'column', sm: 'row' },
    gap: 1,
    mb: 1,
  },
  decisionTitle: {
    fontWeight: 900,
    lineHeight: 1.2,
  },
  decisionStatusChip: {
    fontWeight: 900,
    bgcolor: 'primary.main',
    color: 'primary.contrastText',
    height: 28,
    flexShrink: 0,
  },
  decisionSummary: {
    color: 'text.primary',
    fontWeight: 500,
    mb: 1.5,
  },
  briefGrid: {
    display: 'grid',
    gridTemplateColumns: {
      xs: '1fr',
      md: 'repeat(3, minmax(0, 1fr))',
    },
    gap: 1.5,
    mb: 1.5,
  },
  whyBox: {
    p: 1.25,
    borderRadius: 1,
    bgcolor: 'custom.surfaceAlt',
  },
  supportingSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
    pt: 1,
    borderTop: '1px solid',
    borderColor: 'custom.surfaceAlt',
  },
  sectionTitle: {
    fontWeight: 800,
    mb: 1,
  },
  sectionTitleNoMargin: {
    fontWeight: 800,
  },
  panelTitleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
    mb: 1,
  },
  statusChip: {
    height: 24,
    fontWeight: 800,
    bgcolor: 'background.paper',
    color: 'primary.main',
    border: '1px solid',
    borderColor: 'custom.surfaceAlt',
    flexShrink: 0,
  },
  insightStack: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1.25,
  },
  insightItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.75,
    p: 1.25,
    borderRadius: 1,
    bgcolor: 'background.paper',
    border: '1px solid',
    borderColor: 'custom.surfaceAlt',
  },
  priorityItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.75,
    p: 1.25,
    borderRadius: 1,
    bgcolor: 'background.paper',
    border: '1px solid',
    borderColor: 'custom.surfaceAlt',
  },
  insightTitle: {
    fontWeight: 800,
  },
  list: {
    m: 0,
    pl: 2.5,
  },
  listItem: {
    marginBottom: 0.75,
  },
  graphGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 1.5,
  },
  graphSection: {
    p: 1.5,
    borderRadius: 2,
    bgcolor: 'custom.surfaceAlt',
    border: '1px solid',
    borderColor: 'custom.surfaceAlt',
  },
  graphRows: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1.25,
  },
  graphRow: {
    minWidth: 0,
  },
  graphRowHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
    mb: 0.5,
  },
  graphLabel: {
    fontWeight: 700,
    minWidth: 0,
  },
  graphBarTrack: {
    height: 9,
    borderRadius: 999,
    overflow: 'hidden',
    bgcolor: 'custom.surfaceAlt',
    display: 'flex',
  },
  graphBarSegment: (width, bgcolor) => ({
    width: `${Math.max(0, Math.min(width, 100))}%`,
    bgcolor,
  }),
  graphLegend: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 1,
    mt: 0.5,
    flexWrap: 'wrap',
  },
  drilldownPanel: {
    borderRadius: 2,
    bgcolor: 'custom.surfaceAlt',
    border: '1px solid',
    borderColor: 'custom.surfaceAlt',
    overflowX: 'auto',
  },
  drilldownIntro: {
    p: 1.5,
    pb: 1,
  },
  drilldownHeader: {
    display: 'grid',
    gridTemplateColumns:
      'minmax(300px, 1.7fr) 64px 76px 76px minmax(150px, 0.9fr) 104px 104px 220px',
    gap: 1,
    alignItems: 'center',
    minWidth: 960,
    px: 1.5,
    py: 1,
    color: 'text.secondary',
    fontSize: '0.75rem',
    fontWeight: 800,
    borderTop: '1px solid',
    borderBottom: '1px solid',
    borderColor: 'custom.surfaceAlt',
  },
  drilldownBody: (forFailedRuns = false) =>
    forFailedRuns
      ? {
          minWidth: 960,
          minHeight: 420,
          overflowY: 'auto',
        }
      : {
          minWidth: 960,
          maxHeight: 420,
          overflowY: 'auto',
        },
  drilldownAccordion: (riskLevel = 'low') => ({
    bgcolor: {
      high: 'error.secondary',
      medium: 'custom.surfaceAlt',
      low: 'success.secondary',
    }[riskLevel],
    borderBottom: '1px solid',
    borderBottomColor: 'custom.surfaceAlt',
    borderLeft: '4px solid',
    borderLeftColor: {
      high: 'error.main',
      medium: 'warning.main',
      low: 'success.main',
    }[riskLevel],
    '&:before': {
      display: 'none',
    },
  }),
  drilldownSummary: (riskLevel = 'low') => ({
    px: 1.5,
    py: 0,
    '& .MuiAccordionSummary-content': {
      my: 0,
    },
    '&:hover': {
      bgcolor: {
        high: 'error.secondary',
        medium: 'custom.surfaceAlt',
        low: 'custom.surfaceAlt',
      }[riskLevel],
    },
  }),
  drilldownFlowRow: {
    display: 'grid',
    gridTemplateColumns: 'minmax(300px, 1.7fr) 64px 76px 76px minmax(150px, 0.9fr) 104px 104px',
    gap: 1,
    alignItems: 'center',
    width: '100%',
    py: 1,
  },
  drilldownDetails: {
    p: 0,
    bgcolor: 'custom.surfaceAlt',
  },
  drilldownScenarioRow: (riskLevel = 'low') => ({
    display: 'grid',
    gridTemplateColumns:
      'minmax(300px, 1.7fr) 64px 76px 76px minmax(150px, 0.9fr) 104px 104px 220px',
    gap: 1,
    alignItems: 'center',
    px: 1.5,
    borderTop: '1px solid',
    borderColor: 'custom.surfaceAlt',
    bgcolor: {
      high: 'error.secondary',
      medium: 'custom.surfaceAlt',
      low: 'custom.surfaceAlt',
    }[riskLevel],
  }),
  drilldownLabelCell: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    minWidth: 0,
  },
  drilldownLabelText: {
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 0.25,
  },
  drilldownTitleLine: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  flowChip: {
    height: 22,
    bgcolor: 'custom.surfaceAlt',
    color: 'info.main',
    fontWeight: 800,
    fontSize: '0.68rem',
  },
  scenarioChip: {
    height: 22,
    bgcolor: 'success.secondary',
    color: 'success.main',
    fontWeight: 800,
    fontSize: '0.68rem',
  },
  riskChip: (riskLevel = 'low') => ({
    height: 22,
    flexShrink: 0,
    bgcolor: {
      high: 'error.secondary',
      medium: 'custom.surfaceAlt',
      low: 'success.secondary',
    }[riskLevel],
    color: {
      high: 'error.main',
      medium: 'warning.main',
      low: 'success.main',
    }[riskLevel],
    border: '1px solid',
    borderColor: {
      high: 'error.main',
      medium: 'warning.main',
      low: 'success.main',
    }[riskLevel],
    fontWeight: 800,
    fontSize: '0.68rem',
  }),
  totalText: {
    fontWeight: 700,
  },
  completedText: {
    color: 'success.main',
    fontWeight: 800,
  },
  failedText: {
    color: 'error.main',
    fontWeight: 800,
  },
  durationText: (tone = 'neutral') => ({
    color: {
      passed: 'success.main',
      failed: 'error.main',
      neutral: 'primary.main',
    }[tone],
    fontWeight: 800,
    bgcolor: {
      passed: 'success.secondary',
      failed: 'error.secondary',
      neutral: 'custom.terminalTextLine',
    }[tone],
    borderRadius: 1,
    px: 1,
    py: 0.35,
    display: 'inline-flex',
    justifyContent: 'center',
    width: 'fit-content',
  }),
  drilldownOutcomeCell: {
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 0.35,
  },
  drilldownOutcomeBar: {
    display: 'flex',
    height: 9,
    overflow: 'hidden',
    borderRadius: 999,
    bgcolor: 'custom.surfaceAlt',
  },
  drilldownOutcomeSegment: (width, bgcolor) => ({
    width: `${Math.max(0, Math.min(width, 100))}%`,
    bgcolor,
  }),
  drilldownEmptyState: {
    p: 2,
  },
  drilldownEmptyScenario: {
    p: 2,
    pl: 5,
  },
  emptyState: {
    p: 2,
    borderRadius: 2,
    bgcolor: 'custom.surfaceAlt',
    border: '1px dashed',
    borderColor: 'custom.terminalBg',
    color: 'text.secondary',
  },
  alert: {
    mb: 2,
  },
};
